import React from "react";
import "../../styles/PT-BR/carrosselLogos.css";

// Logos dos clientes — adicione novas logos em src/img/logos/ e importe aqui
import logoAddee from "../../img/logos/Addee.png";
import logoAdemicon from "../../img/logos/Ademicon.png";
import logoAethra from "../../img/logos/Aethra.png";
import logoAGLSolucoes from "../../img/logos/AGL Solucoes.png";
import logoAlice from "../../img/logos/Alice.png";
import logoAligntech from "../../img/logos/Aligntech.png";
import logoAmbev from "../../img/logos/Ambev.png";
import logoAssurant from "../../img/logos/Assurant.png";
import logoAzulSeguros from "../../img/logos/Azul Seguros.png";
import logoBASF from "../../img/logos/BASF.png";
import logoBayer from "../../img/logos/Bayer.png";
import logoBiogen from "../../img/logos/Biogen.png";
import logoBloomberg from "../../img/logos/Bloomberg Philanthropies.png";
import logoBMOutrosPaises from "../../img/logos/BM outros paises.png";
import logoBooking from "../../img/logos/Booking.com.png";
import logoCofco from "../../img/logos/Cofco.png";
import logoColoplast from "../../img/logos/Coloplast.png";
import logoContabilizei from "../../img/logos/Contabilizei.png";
import logoCutrale from "../../img/logos/Cutrale.png";
import logoDasa from "../../img/logos/Dasa.png";
import logoDeloitte from "../../img/logos/Deloitte.png";
import logoDexco from "../../img/logos/Dexco.png";
import logoDigitalSaude from "../../img/logos/Digital Saude.png";
import logoElectrolux from "../../img/logos/Electrolux.png";
import logoEmbratel from "../../img/logos/Embratel.png";
import logoFarmazon from "../../img/logos/Farmazon.png";
import logoFlash from "../../img/logos/Flash.png";
import logoGrupoAguas from "../../img/logos/Grupo Aguas do Brasil.png";
import logoGrupoItapemirim from "../../img/logos/Grupo Itapemirim.png";
import logoGuerini from "../../img/logos/Guerini.png";
import logoHeptagono from "../../img/logos/Heptagono.png";
import logoiFood from "../../img/logos/iFood.png";
import logoImpar from "../../img/logos/Impar Servicos Hospitalares S.A.png";
import logoInventaApp from "../../img/logos/Inventa App.png";
import logoLBV from "../../img/logos/LBV.png";
import logoLiberty from "../../img/logos/Liberty Seguros.png";
import logoLoft from "../../img/logos/Loft.png";
import logoMarfrig from "../../img/logos/Marfrig Bassi.png";
import logoMercafacil from "../../img/logos/Mercafacil.png";
import logoMobly from "../../img/logos/Mobly.png";
import logoOcyan from "../../img/logos/Ocyan.png";
import logoOiSolucoes from "../../img/logos/Oi Solucoes.png";
import logoPlena from "../../img/logos/Plena Saude.png";
import logoPluris from "../../img/logos/Pluris Midia.png";
import logoPorto from "../../img/logos/Porto.png";
import logoPrevent from "../../img/logos/Prevent Senior.png";
import logoPetrobras from "../../img/logos/Saude Petrobras.png";
import logoSchuyler from "../../img/logos/Schuyler.png";
import logoSomente from "../../img/logos/Somente.png";
import logoStone from "../../img/logos/Stone.png";
import logoTMOV from "../../img/logos/TMOV.png";
import logoVitta from "../../img/logos/Vitta.png";
import logoVolvo from "../../img/logos/Volvo Trucks.png";
import logoZebrands from "../../img/logos/Zebrands.png";

const logos = [
  { src: logoAddee, alt: "Addee" },
  { src: logoAdemicon, alt: "Ademicon" },
  { src: logoAethra, alt: "Aethra" },
  { src: logoAGLSolucoes, alt: "AGL Soluções" },
  { src: logoAlice, alt: "Alice" },
  { src: logoAligntech, alt: "Aligntech" },
  { src: logoAmbev, alt: "Ambev" },
  { src: logoAssurant, alt: "Assurant" },
  { src: logoAzulSeguros, alt: "Azul Seguros" },
  { src: logoBASF, alt: "BASF" },
  { src: logoBayer, alt: "Bayer" },
  { src: logoBiogen, alt: "Biogen" },
  { src: logoBloomberg, alt: "Bloomberg Philanthropies" },
  { src: logoBMOutrosPaises, alt: "BM outros países" },
  { src: logoBooking, alt: "Booking.com" },
  { src: logoCofco, alt: "Cofco" },
  { src: logoColoplast, alt: "Coloplast" },
  { src: logoContabilizei, alt: "Contabilizei" },
  { src: logoCutrale, alt: "Cutrale" },
  { src: logoDasa, alt: "Dasa" },
  { src: logoDeloitte, alt: "Deloitte" },
  { src: logoDexco, alt: "Dexco" },
  { src: logoDigitalSaude, alt: "Digital Saúde" },
  { src: logoElectrolux, alt: "Electrolux" },
  { src: logoEmbratel, alt: "Embratel" },
  { src: logoFarmazon, alt: "Farmazon" },
  { src: logoFlash, alt: "Flash" },
  { src: logoGrupoAguas, alt: "Grupo Águas do Brasil" },
  { src: logoGrupoItapemirim, alt: "Grupo Itapemirim" },
  { src: logoGuerini, alt: "Guerini" },
  { src: logoHeptagono, alt: "Heptágono" },
  { src: logoiFood, alt: "iFood" },
  { src: logoImpar, alt: "Impar Serviços Hospitalares" },
  { src: logoInventaApp, alt: "Inventa App" },
  { src: logoLBV, alt: "LBV" },
  { src: logoLiberty, alt: "Liberty Seguros" },
  { src: logoLoft, alt: "Loft" },
  { src: logoMarfrig, alt: "Marfrig Bassi" },
  { src: logoMercafacil, alt: "Mercafácil" },
  { src: logoMobly, alt: "Mobly" },
  { src: logoOcyan, alt: "Ocyan" },
  { src: logoOiSolucoes, alt: "Oi Soluções" },
  { src: logoPlena, alt: "Plena Saúde" },
  { src: logoPluris, alt: "Pluris Mídia" },
  { src: logoPorto, alt: "Porto" },
  { src: logoPrevent, alt: "Prevent Senior" },
  { src: logoPetrobras, alt: "Saúde Petrobras" },
  { src: logoSchuyler, alt: "Schuyler" },
  { src: logoSomente, alt: "Somente" },
  { src: logoStone, alt: "Stone" },
  { src: logoTMOV, alt: "TMOV" },
  { src: logoVitta, alt: "Vitta" },
  { src: logoVolvo, alt: "Volvo Trucks" },
  { src: logoZebrands, alt: "Zebrands" },
];

function CarrosselLogos() {
  // Duplicamos o array para criar o efeito de loop infinito contínuo
  const logosDuplicados = [...logos, ...logos];

  return (
    <div className="carrossel-logos-wrapper">
      <div className="carrossel-logos-track">
        {logosDuplicados.map((logo, index) => (
          <div className="carrossel-logos-item" key={index}>
            <img src={logo.src} alt={logo.alt} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default CarrosselLogos;
